const { BettyHistoryModule } = await import("uidispatcher_api/UidispatcherApiModule");
export default BettyHistoryModule;
